import React, {Component} from "react";
import Menu from "../Menu";
import EditablePost from "../EditablePost";
import Post from "../Post";
import {Get, Add} from "../../api/Menu";
import {inject} from "mobx-react";

class Content extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            editable: false,
            menu: [],
            phone: false,
        };
    };

    componentDidMount() {
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            this.setState({
                phone: true
            })
          } else {
            this.setState({
                phone: false
            })
        }
        this.loadMenu();
    }

    changeVisible = async () => {
        this.setState({
            loading: !this.state.loading
        })
    };

    loadMenu = async () => {
        const path = window.location.pathname;

        const resp = await Get(path.replace("/", ""));

        const data = await resp.json();


        this.setState({
            loading: false,
            menu: data.map((item) => {
                return {
                    id: item.id,
                    href: item.href,
                    isEdit: false,
                    isRoot: item.isRoot,
                    items: item.items,
                    menuId: item.menuId,
                    name: item.name,
                    postId: item.postId,
                    color: item.color
                }
            })
        })
    };

    resetEditStatus = (menu) => {
        return menu.map((item) => {
            item.isEdit = false;

            item.items = this.resetEditStatus(item.items);

            return item;
        })
    };

    setEditStatus = (menu, id) => {
        return menu.map((item) => {
            if (item.id === id) {
                item.isEdit = true
            }

            item.items = this.setEditStatus(item.items, id);

            return item;
        })
    };

    edit = (id) => {
        let menu = this.state.menu;

        menu = this.resetEditStatus(menu);


        menu = this.setEditStatus(menu, id);


        this.setState({
            menu: menu
        }, () => {
            this.setState({
                editable: true
            })
        });
    };

    setNewChild = (menu, parentId) => {
        return menu.map((item) => {
            if (item.id === parentId) {
                item.items.push({
                    isEdit: true,
                    id: null,
                    postId: null,
                    name: null,
                    menuId: parentId,
                    color: null,
                    items: []
                });
            }

            item.items = this.setNewChild(item.items, parentId);

            return item;
        })
    };

    addChildMenu = (parentId) => {
        let menu = this.state.menu;
        menu = this.setNewChild(menu, parentId);

        this.setState({
            menu: menu
        }, () => {
            this.changeEditable();
        });
    };

    addRootMenu = () => {
        const menu = this.state.menu;

        menu.push({
            isEdit: true,
            id: null,
            postId: null,
            name: null,
            menuId: null,
            color: null,
            items: []
        });

        this.setState({
            menu: menu
        }, () => {
            this.changeEditable();
        });
    };

    changeEditable = () => {
        this.setState({
            editable: !this.state.editable
        })
    };

    render() {
        return (
            <>
                {
                    this.state.loading &&
                    <div id="overlay">
                        <div className={"circle"}>
                        </div>
                    </div>
                }
                {
                    !this.state.loading &&
                    <>
                        <Menu
                            edit={this.edit}
                            editable={this.state.editable}
                            addChildMenu={this.addChildMenu}
                            addRootMenu={this.addRootMenu} menu={this.state.menu}
                            showBanner={this.props.showBanner}
                            />
                        {
                            !this.state.editable &&
                            
                                <Post menu={this.state.menu}
                                showBanner={this.props.showBanner}
                                />
                            
                        }

                        {
                            this.state.editable &&
                            <div style={{paddingRight: 70, marginTop: this.props.showBanner && !this.state.phone ? 85 : 0}} className="site__content">
                                <EditablePost
                                    changeVisible={this.changeVisible} menu={this.state.menu}
                                    changeEditable={this.changeEditable}/>
                            </div>
                        }
                    </>
                }
            </>
        )
    }
}

export default Content;